import { reduce } from "et3-type-guards";
import { useState } from "react";
import { Link } from "react-router-dom";

import i18n from "../../../constants/i18n";
import { DEPRECATED_SIDE_BAR_LINKS } from "../../../constants/deprecated-routes";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";
import { TSubMenuDropDownItemProps } from "../../../Types";
import {
  SIDE_BAR_ACCENT_RADIUS,
  SIDE_BAR_ACCENT_WIDTH,
  SIDE_BAR_SUB_GAP,
  SIDE_BAR_SUB_PADDING_RIGHT,
  SIDE_BAR_LABEL_MUTED,
  SIDE_BAR_ROW_ACTIVE_BACKGROUND,
  SIDE_BAR_ROW_HOVER_BACKGROUND,
  SIDE_BAR_SUB_FONT_SIZE,
  SIDE_BAR_SUB_HEIGHT,
  SIDE_BAR_SUB_INDENT,
  SIDE_BAR_SUB_RADIUS,
  SIDE_BAR_TAG_BACKGROUND,
  SIDE_BAR_TAG_COLOR,
  SIDE_BAR_TAG_FONT_SIZE,
  SIDE_BAR_TAG_HEIGHT,
  SIDE_BAR_TAG_LETTER_SPACING,
  SIDE_BAR_TAG_PADDING,
  SIDE_BAR_TAG_RADIUS,
  SIDE_BAR_TRANSITION
} from "../side-bar-constants";

const SubMenuDropDownItem = withLiteObserverAndTheme<TSubMenuDropDownItemProps>(
  (props) => {
    const { option, theme, isSelected, visible } = props;
    const { colors, unitX } = theme;
    const [isHovered, setIsHovered] = useState(false);
    const isDeprecated = DEPRECATED_SIDE_BAR_LINKS.includes(
      reduce(() => option.link, "")
    );

    const backgroundColor = (() => {
      switch (true) {
        case isSelected:
          return SIDE_BAR_ROW_ACTIVE_BACKGROUND;
        case isHovered:
          return SIDE_BAR_ROW_HOVER_BACKGROUND;
        default:
          return colors.all.transparent;
      }
    })();

    const labelColor = (() => {
      switch (true) {
        case isSelected:
          return colors.all.white;
        case isHovered:
          return colors.all.white;
        default:
          return SIDE_BAR_LABEL_MUTED;
      }
    })();

    return !visible ? null : (
      <Link
        to={option.link}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          textDecoration: "none",
          display: "block",
          flexShrink: 0,
          width: "100%"
        }}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={0}
          height={SIDE_BAR_SUB_HEIGHT}
          fDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          color={backgroundColor}
          style={{
            boxSizing: "border-box",
            width: "100%",
            minWidth: 0,
            flexShrink: 0,
            borderRadius: SIDE_BAR_SUB_RADIUS * unitX,
            paddingLeft: SIDE_BAR_SUB_INDENT * unitX,
            paddingRight: SIDE_BAR_SUB_PADDING_RIGHT * unitX,
            gap: SIDE_BAR_SUB_GAP * unitX,
            transition: SIDE_BAR_TRANSITION
          }}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={SIDE_BAR_ACCENT_WIDTH}
            height={SIDE_BAR_SUB_FONT_SIZE}
            fDirection="row"
            alignItems="center"
            justifyContent="center"
            color={isSelected ? colors.all.bondiBlue : colors.all.transparent}
            style={{
              flexShrink: 0,
              borderRadius: SIDE_BAR_ACCENT_RADIUS * unitX,
              transition: SIDE_BAR_TRANSITION
            }}
            onClick={() => {}}
          />
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={SIDE_BAR_SUB_FONT_SIZE}
            text={option.title}
            isSpan={false}
            color={labelColor}
            style={{
              margin: 0,
              minWidth: 0,
              textAlign: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              transition: SIDE_BAR_TRANSITION
            }}
          />
          {!isDeprecated ? null : (
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={0}
              height={SIDE_BAR_TAG_HEIGHT}
              fDirection="row"
              alignItems="center"
              justifyContent="center"
              color={SIDE_BAR_TAG_BACKGROUND}
              style={{
                boxSizing: "border-box",
                width: "auto",
                minWidth: 0,
                flexShrink: 0,
                marginLeft: "auto",
                whiteSpace: "nowrap",
                borderRadius: SIDE_BAR_TAG_RADIUS * unitX,
                paddingLeft: SIDE_BAR_TAG_PADDING * unitX,
                paddingRight: SIDE_BAR_TAG_PADDING * unitX
              }}
              onClick={() => {}}
            >
              <Et3Text
                fontFamily={"BOLD"}
                fontSize={SIDE_BAR_TAG_FONT_SIZE}
                text={i18n.get("DEPRECATED")}
                isSpan={true}
                color={SIDE_BAR_TAG_COLOR}
                style={{
                  margin: 0,
                  textTransform: "uppercase",
                  letterSpacing: SIDE_BAR_TAG_LETTER_SPACING * unitX
                }}
              />
            </ET3Div>
          )}
        </ET3Div>
      </Link>
    );
  }
);

export default SubMenuDropDownItem;
